import { IntegrationsArray } from './intergrationOptions';
import {
	BackgroundValues,
	ClockTypes,
	FontValues,
	ModeValues,
	OpacityValues,
	SearchBarOptionsValues,
	SearchBarStyleValues,
	SelectedBookmarks,
	SidebarBackgroundValues,
	ViewValues
} from './optionsValues';

export type TopicBookmark = {
	name: string;
	url: string;
};

export type AppearanceStyle = {
	mode: ModeValues;
	opacity: OpacityValues;
	view: ViewValues;
	font: FontValues;
};

export type SearchEngineStyles = {
	searchEngine: string;
	type: SearchBarStyleValues;
	colored: boolean;
	border: boolean;
	openNewTab: boolean;
	size: number;
};

export type FocusStyle = {
	myFocus?: string;
	size?: number;
};

export type GreetingStyle = {
	size: number;
};

type BookmarkStyles = {
	blackAndWhite: boolean;
	square: boolean;
	openNewTab: boolean;
	selectedBookmarks: SelectedBookmarks;
	size: number;
	gap: number;
};

type ClockStyles = {
	kind: ClockTypes;
	size: number;
	boldness?: number;
	showSeconds?: boolean;

	isDark?: boolean;
	isNumbered?: boolean;

	showTwentyFour?: boolean;
	showAmPm?: boolean;
};

type FeaturesStyles = {
	time: boolean;
	date: boolean;
	searchBar: boolean;
	quote: boolean;
	notes: boolean;
	weather: boolean;
	bookmarks: boolean;
	integrations: boolean;
};

export type IntegrationType = {
	category: string;
	name: string;
	categorySlug: string;
	nameSlug: string;
};

export type QuoteStyle = {
	size: number;
	useCustomQuote: boolean;
	customQuote?: string;
};

export type SidebarStyle = {
	width: number;
	contentWidth: number;
	view: SidebarBackgroundValues;
};

export type WallpaperStyle = {
	background: BackgroundValues;
	blur: number;
	brightness: number;
};

export type TopicStyles = {
	appearanceStyle: AppearanceStyle;
	bookmarkStyle: BookmarkStyles;
	clock: ClockStyles;
	featuresStyle: FeaturesStyles;
	searchbarOptions: SearchBarOptionsValues;
	searchEngines: SearchEngineStyles[];
	greetingStyle?: GreetingStyle;
	focusStyle?: FocusStyle;
	integrationsStyle: IntegrationType[];
	defaultBookmarkList?: TopicBookmark[];
	quoteStyle: QuoteStyle;
	wallpaperStyle: WallpaperStyle;
	sidebarStyle: SidebarStyle;
};

export const BasicTopicStyle: TopicStyles = {
	appearanceStyle: {
		font: FontValues.STANDARD,
		mode: ModeValues.SYSTEM,
		opacity: OpacityValues.TRANSLUCENT,
		view: ViewValues.CONTRACTED
	},

	clock: {
		kind: ClockTypes.Digital,
		size: 35,
		boldness: 50,
		showSeconds: false,
		showAmPm: true,
		showTwentyFour: false
	},

	featuresStyle: {
		time: true,
		date: true,
		searchBar: true,
		quote: true,
		weather: true,
		bookmarks: true,
		notes: true,
		integrations: true
	},

	wallpaperStyle: {
		background: BackgroundValues.PICTURE,
		blur: 0,
		brightness: 1
	},
	quoteStyle: {
		size: 25,
		useCustomQuote: false,
		customQuote: ''
	},

	sidebarStyle: {
		width: 33,
		contentWidth: 360,
		view: SidebarBackgroundValues.SOLID
	},

	searchbarOptions: SearchBarOptionsValues.SEARCHBAR,

	// focusStyle: {
	// 	myFocus: '',
	// 	size: 40
	// },

	// greetingStyle: {
	// 	size: 40
	// },

	searchEngines: [
		{
			searchEngine: 'google',
			type: SearchBarStyleValues.ROUNDED,
			openNewTab: true,
			colored: true,
			border: true,
			size: 35
		},
		{
			searchEngine: 'youtube',
			type: SearchBarStyleValues.ROUNDED,
			openNewTab: true,
			colored: true,
			border: true,
			size: 35
		},
		{
			searchEngine: 'gdrive',
			type: SearchBarStyleValues.ROUNDED,
			openNewTab: true,
			colored: true,
			border: true,
			size: 35
		},
		{
			searchEngine: 'amazon',
			type: SearchBarStyleValues.ROUNDED,
			openNewTab: true,
			colored: true,
			border: true,
			size: 35
		}
	],

	integrationsStyle: [
		IntegrationsArray[0],
		IntegrationsArray[5],
		IntegrationsArray[4]
	],

	bookmarkStyle: {
		selectedBookmarks: SelectedBookmarks.TOP_VISITED,
		blackAndWhite: false,
		square: false,
		openNewTab: true,
		gap: 10,
		size: 45
	},

	defaultBookmarkList: [
		{
			name: 'Google',
			url: 'www.google.com'
		},
		{
			name: 'Gmail',
			url: 'www.gmail.com'
		},
		{
			name: 'Youtube',
			url: 'www.youtube.com'
		},
		{
			name: 'facebook',
			url: 'www.facebook.com'
		},
		{
			name: 'Instagram',
			url: 'www.instagram.com'
		},
		{
			name: 'Netflix',
			url: 'www.netflix.com'
		},
		{
			name: 'Amazon',
			url: 'www.amazon.com'
		}
	]
};
